import { Component, OnInit, ViewChild, HostListener, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-debug-tool',
  templateUrl: './debug-tool.component.html',
  styleUrls: ['./debug-tool.component.scss']
})
export class DebugToolComponent implements OnInit {
  @ViewChild('insideElement') insideElement;
  @ViewChild('dialogue') dialogue;
  @Output() taskID: EventEmitter<number> = new EventEmitter<number>();
  debugCounter = 0;
  task;
  @HostListener('document:click', ['$event.target'])
  onClick(targetElement) {
    const clickedInside = this.insideElement.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.debugCounter = 0;
    }
  }

  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
  }

  openDebug(): void {
    if (this.debugCounter === 4) {
      console.log('%c Debug tool opened', 'color: green; font-size: medium');
      this.dialog.open(this.dialogue, {
        width: '250px',
      });
    } else {
      this.debugCounter += 1;
    }
  }

  onNoClick(): void {
    this.debugCounter = 0;
    this.dialog.closeAll();
    console.log('%c Debug tool closed', 'color: blue; font-size: medium');
  }

  onOkClick(): void {
    this.taskID.emit(this.task);
    this.onNoClick();
  }

}
